import React, { useState, useRef, useEffect } from "react";
import { Allotment } from "allotment";
import "allotment/dist/style.css";
import {
  ArrowClockwise,
  ArrowCounterclockwise,
  ArrowsCollapse,
  ArrowsExpand,
  Code,
  Copy,
  Crosshair,
  Download,
  Floppy,
  Fonts,
  Grid,
  Image,
  List,
  ListUl,
  Moon,
  Pencil,
  Play,
  Search,
  Sun,
  UiRadiosGrid,
  ZoomIn,
  ZoomOut,
} from "react-bootstrap-icons";
import Navbar from "./Navbar";
import Modal from "./Modal";
import MyEditor from "./MyEditor";
import OneChoiceGenerator from "./tools/generators/OneChoiceGenerator";
import BulletListGenerator from "./tools/generators/BulletListGenerator";
import ImageGenerator from "./tools/generators/ImageGenerator";
import ImageMarkerGenerator from "./tools/generators/ImageMarkerGenerator";
import SortingGenerator from "./tools/generators/SortingGenerator";
import FlipCardGenerator from "./tools/generators/FlipCardGenerator";
import FlipCardGridGenerator from "./tools/generators/FlipCardGridGenerator";
import TextGenerator from "./tools/generators/TextGenerator";
import VideoGenerator from "./tools/generators/VideoGenerator";
import IframeGenerator from "./tools/generators/IframeGenerator";

// Für dein Backend:
const SERVER_URL = "https://api.edit.guru-x.de";

export default function Main() {
  const [lernmodul, setLernmodul] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const debounceTimer = useRef(null);
  const [session, setSession] = useState("");
  const [dragOver, setDragOver] = useState(false);
  const [autoRefresh, setAutoRefresh] = useState(false);
  const textareaRef = useRef();

  const onDragOver = (ev) => {
    ev.preventDefault();
    setDragOver(true);
  };
  const onDragLeave = (ev) => {
    ev.preventDefault();
    setDragOver(false);
  };

  const onDrop = async (ev) => {
    ev.preventDefault();
    setDragOver(false);

    const files = ev.dataTransfer.files;
    if (!files || files.length === 0) {
      setUploading(false);
      return;
    }

    const file = files[0];
    // Check MIME type or file extension (.zip)
    const isZip =
      file.type === "application/zip" ||
      file.type === "application/x-zip-compressed" ||
      file.name.toLowerCase().endsWith(".zip");

    if (!isZip) {
      alert("Please drop a zip file.");
      setUploading(false);
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);
    const res = await fetch(`${SERVER_URL}/upload_zip`, {
      method: "POST",
      body: formData,
    });
    const data = await res.json();
    setSession(data.session);
    setLernmodul(data.lernmodul_js || "");
    const newPreviewUrl = data.preview_url + "?t=" + Date.now();
    setPreviewUrl(newPreviewUrl);
    setUploading(false);
  };

  const onLernmodulChange = (e) => {
    const val = e.target.value;
    setLernmodul(val);
    /*
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }
    debounceTimer.current = setTimeout(async () => {
      setLoading(true);
      const res = await fetch(`${SERVER_URL}/save_lernmodul/${session}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: val }),
      });
      const data = await res.json();
      if (autoRefresh) {
        setPreviewUrl(data.preview_url + "?t=" + Date.now());
      }
      setLoading(false);
    }, 1500);*/
  };
  const refresh = async (val) => {
    setLoading(true);
    const res = await fetch(`${SERVER_URL}/save_lernmodul/${session}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code: val }),
    });
    const data = await res.json();

    // Only update previewUrl if autoRefresh is true
    if (autoRefresh) {
      setPreviewUrl(data.preview_url + "?t=" + Date.now());
    }

    setLoading(false);
  };

  const iframeRef = useRef(null);
  // Handler: on scroll in code editor

  const [modalText, setModalText] = useState("");

  const openModal = (text) => {
    setModalText(text);
    console.log(document.getElementById("generator_result_modal").showModal());
    //document.getElementById("generator_result_modal").showModal();
  };
  const saveHandler = (event) => {
    // ctrl+s or cmd+s (for Mac)
    if ((event.ctrlKey || event.metaKey) && event.key === "s") {
      event.preventDefault(); // Prevent default browser 'save page'
      handleFormatDocument();
      refresh(lernmodul); // Call your custom save function
    }
  };
  const [isDark, setIsDark] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  useEffect(() => {
    isCollapsed ? handleFoldAll() : handleUnfoldAll();
  }, [isCollapsed]);
  // Monaco gibt kein ref auf die textarea direkt aus,
  // Aber falls du ein Ref brauchst:
  const editorRef = useRef(null);
  function handleUnfoldAll() {
    if (editorRef.current) {
      editorRef.current.getAction("editor.unfoldAll")?.run();
      // Scroll to top
      editorRef.current.revealLine(1);
      // Optionally also move the cursor:
      editorRef.current.setPosition({ lineNumber: 1, column: 1 });
    }
  }
  function handleFoldAll() {
    if (editorRef.current) {
      editorRef.current.getAction("editor.foldAll")?.run();
    }
  }
  function handleOpenSearch() {
    if (editorRef.current) {
      editorRef.current.getAction("actions.find")?.run();
    }
  }
  function handleFormatDocument() {
    if (editorRef.current) {
      editorRef.current.getAction("editor.action.formatDocument").run();
    }
  }
  function handleEditorDidMount(editor, monaco) {
    editorRef.current = editor;
    /*editor.addCommand(monaco.KeyMod.CtrlCmd | monaco.KeyCode.KeyS, () => {
      // const currentValue = editor.getValue();
      // if (saveHandler) saveHandler(currentValue);
    });*/
  }
  const [fontSize, setFontSize] = useState(16);
  function handleZoomIn() {
    setFontSize((size) => Math.min(size + 2, 40));
  }
  function handleZoomOut() {
    setFontSize((size) => Math.max(size - 2, 8));
  }
  function handleResetZoom() {
    setFontSize(16);
  }
  function handleUndo() {
    if (editorRef.current) {
      // Approach 1: Using built-in undo
      if (typeof editorRef.current.undo === "function") {
        editorRef.current.undo();
      } else {
        // Approach 2: Fallback to trigger
        editorRef.current.trigger("", "undo", null);
      }
    }
  }

  function handleRedo() {
    if (editorRef.current) {
      if (typeof editorRef.current.redo === "function") {
        editorRef.current.redo();
      } else {
        editorRef.current.trigger("", "redo", null);
      }
    }
  }
  const [currentId, setCurrentId] = React.useState(null);
  const [showEdior, setShowEditor] = useState(false);
  return (
    <div>
      {/**   <Navbar
        openModal={openModal}
        lernmodul={lernmodul}
        session={session}
        uploading={uploading}
        SERVER_URL={SERVER_URL}
        refresh={refresh}
      />*/}
      <Modal generatedCode={modalText}></Modal>
      <div style={{ height: "95vh", width: "100%" }}>
        <Allotment defaultSizes={[1, 1]} minSize={100}>
          {/* Linke Seite: Editor */}
          <div className="flex flex-col h-full ">
            <div className="text-center   ">
              {/**   <b>Learning Module</b>{" "}*/}
              <div className=" navbar min-h-0 my-0  ">
                <div className="navbar-end gap-0 flex flex-wrap w-full ">
                  <div
                    className="tooltip tooltip-bottom z-10"
                    data-tip="Save & open preview"
                  >
                    <button
                      className="btn btn-ghost  btn-circle"
                      disabled={!session || uploading}
                      onClick={() => {
                        window.open(
                          "https://test.guru-x.de" +
                            previewUrl +
                            (loading
                              ? "?t=" + Date.now() + "#" + currentId
                              : "#" + currentId)
                        );
                        refresh(lernmodul);
                      }}
                    >
                      <Play
                        className="w-7 h-7 text-black-400 mortiHover"
                        //  size={30}
                      ></Play>
                    </button>
                  </div>
                  <div className="tooltip tooltip-bottom z-10" data-tip="Save">
                    <button
                      className="btn btn-ghost  btn-circle"
                      disabled={!session || uploading}
                      onClick={() => refresh(lernmodul)}
                    >
                      <Floppy
                        className="w-5 h-5 text-black-400 mortiHover"
                        //  size={30}
                      ></Floppy>
                    </button>
                  </div>
                  <div
                    className="tooltip tooltip-bottom z-10"
                    data-tip="Add a new element"
                  >
                    <label
                      htmlFor="my-drawer-3"
                      aria-label="open sidebar"
                      flex
                      flex-row
                      className="btn btn-circle btn-ghost "
                      onClick={() => {
                        setShowEditor(true);
                        // setShowIndex(false);
                      }}
                      disabled={!session || uploading}
                    >
                      <Pencil className="w-5 h-5 text-black-400" />
                    </label>
                  </div>
                  <div
                    className="tooltip tooltip-bottom z-10"
                    data-tip="Download"
                  >
                    <button
                      className="btn btn-ghost  btn-circle"
                      disabled={!session || uploading}
                      onClick={async () => {
                        if (!session) return;
                        const response = await fetch(
                          `${SERVER_URL}/download_zip/${session}`
                        );
                        if (!response.ok) {
                          alert("Download fehlgeschlagen!");
                          return;
                        }
                        let filename = `${session}.zip`;
                        const disposition = response.headers.get(
                          "Content-Disposition"
                        );
                        if (
                          disposition &&
                          disposition.indexOf("filename=") !== -1
                        ) {
                          filename = disposition
                            .split("filename=")[1]
                            .split(";")[0]
                            .replace(/"/g, "");
                        }
                        const blob = await response.blob();
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = filename;
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);
                      }}
                    >
                      <Download
                        className="w-5 h-5 text-black-400"
                        //  size={30}
                      ></Download>
                    </button>
                  </div>
                  <div
                    className="tooltip tooltip-bottom z-10"
                    data-tip="Fold/Unfold"
                  >
                    <label className="cursor-pointer  select-none btn btn-circle btn-ghost">
                      <input
                        type="checkbox"
                        className="toggle hidden"
                        checked={isCollapsed}
                        onChange={() => setIsCollapsed((v) => !v)}
                      />
                      <span>
                        {isCollapsed ? (
                          <ArrowsCollapse className="w-5 h-5 text-black-400" />
                        ) : (
                          <ArrowsExpand className="w-5 h-5 text-black-400" />
                        )}
                      </span>
                    </label>
                  </div>
                  <div className="tooltip tooltip-bottom z-10" data-tip="Theme">
                    <label className="cursor-pointer  select-none btn btn-circle btn-ghost">
                      <input
                        type="checkbox"
                        className="toggle hidden"
                        checked={isDark}
                        onChange={() => setIsDark((v) => !v)}
                      />
                      <span>
                        {isDark ? (
                          <Moon className="w-5 h-5 text-black-400" />
                        ) : (
                          <Sun className="w-5 h-5 text-black-400" />
                        )}
                      </span>
                    </label>
                  </div>
                  <div
                    className="tooltip tooltip-bottom z-10"
                    data-tip="Search"
                  >
                    <button
                      onClick={handleOpenSearch}
                      className="btn btn-ghost  btn-circle"
                    >
                      <Search className="w-5 h-5 text-black-400" />
                    </button>
                  </div>
                  <div
                    className="tooltip tooltip-bottom z-10"
                    data-tip="Zoom in"
                  >
                    <button
                      onClick={handleZoomIn}
                      className="btn btn-ghost  btn-circle"
                    >
                      <ZoomIn className="w-5 h-5 text-black-400" />
                    </button>
                  </div>
                  <div
                    className="tooltip tooltip-bottom z-10"
                    data-tip="Zoom out"
                  >
                    <button
                      onClick={handleZoomOut}
                      className="btn btn-ghost  btn-circle"
                    >
                      <ZoomOut className="w-5 h-5 text-black-400" />
                    </button>
                  </div>
                  <div className="tooltip tooltip-bottom z-10" data-tip="Undo">
                    <button
                      onClick={handleUndo}
                      className="btn btn-ghost  btn-circle"
                    >
                      <ArrowCounterclockwise className="w-5 h-5 text-black-400" />
                    </button>
                  </div>
                  <div className="tooltip tooltip-bottom z-10" data-tip="Redo">
                    <button
                      onClick={handleRedo}
                      className="btn btn-ghost  btn-circle"
                    >
                      <ArrowClockwise className="w-5 h-5 text-black-400" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative flex-1" onKeyDown={saveHandler}>
              <MyEditor
                lernmodul={lernmodul}
                onLernmodulChange={setLernmodul}
                dragOver={false} // oder state-basiert, falls du hover visualisieren willst
                onDragOver={onDragOver}
                onDragLeave={onDragLeave}
                onDrop={onDrop}
                isDark={isDark}
                editorRef={editorRef}
                handleEditorDidMount={handleEditorDidMount}
                fontSize={fontSize}
                onVisibleDivIdChange={setCurrentId}
              />
              {dragOver && (
                <div
                  style={{
                    position: "absolute",
                    zIndex: 10,
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "rgba(16,185,129,0.13)",
                    pointerEvents: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: 20,
                    color: "#12704a",
                    //  borderRadius: 8,
                  }}
                >
                  {/**  Drop your ZIP file here!*/}
                </div>
              )}
            </div>
          </div>
          {/* Rechte Seite: Preview */}

          <div className="flex flex-col h-full">
            {/**   <div className="text-center mt-6 py-6">
              <div className="mb-0">
                <b>Preview</b>
              </div>
            </div>*/}
            <div
              style={{
                flex: 1,
                //borderTop: "1px solid #ccc",
                // borderRadius: 8,
                overflow: "hidden",
              }}
            >
              {previewUrl ? (
                <iframe
                  ref={iframeRef}
                  //sandbox="allow-scripts allow-forms allow-downloads"
                  //sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-presentation allow-top-navigation-by-user-activation"
                  sandbox="allow-scripts"
                  referrerPolicy="no-referrer"
                  src={
                    "https://api.edit.guru-x.de" +
                    previewUrl +
                    (loading
                      ? "?t=" + Date.now() + "#" + currentId
                      : "#" + currentId)
                  }
                  style={{ width: "100%", height: "100%", border: "none" }}
                  title="preview"
                />
              ) : (
                <div style={{ color: "#888", padding: 40 }}>
                  {/**Bitte ZIP hochladen!*/}
                </div>
              )}
            </div>
          </div>
        </Allotment>
      </div>
      <div
        draggable="false"
        className="drawer drawer-end "
        style={{ zIndex: 200 }}
      >
        <input id="my-drawer-3" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content flex flex-col"></div>
        <div className="drawer-side ">
          <label
            htmlFor="my-drawer-3"
            aria-label="close sidebar"
            className="drawer-overlay"
          ></label>
          <ul className="text-lg menu p-2 w-3/4 lg:w-1/2  min-h-full bg-base-100 overflow-x-auto ">
            {/* Sidebar content here */}

            {showEdior ? (
              <div>
                {/*
                <div className="collapse collapse-plus join-item border border-base-300 ">
                  <input type="radio" name="my-accordion-4" />
                  <div className="collapse-title ">
                    <div className="flex flex-row items-center">
                      <div className="pr-4">
                        <UiRadiosGrid size={22} />
                      </div>
                      <div className="text-sm lg:text-lg">Multiple Choice</div>{" "}
                    </div>
                  </div>
                  <div className="collapse-content overflow-x-auto ">
                    <OneChoiceGenerator openModal={openModal} />
                  </div>
                </div>
               
                <div className="collapse collapse-plus join-item border border-base-300 ">
                  <input type="radio" name="my-accordion-4" />
                  <div className="collapse-title  ">
                    <div className="flex flex-row items-center ">
                      <div className="pr-4">
                        <Image size={22} />
                      </div>
                      <div className="text-sm lg:text-lg">Labeled Image</div>{" "}
                    </div>
                  </div>
                  <div className="collapse-content  overflow-x-auto">
                    <ImageMarkerGenerator />
                  </div>
                </div>
               
                <div className="collapse collapse-plus join-item border border-base-300">
                  <input type="radio" name="my-accordion-4" />
                  <div className="collapse-title  ">
                    <div className="flex flex-row items-center">
                      <div className="pr-4 rotatex">
                        <Copy size={22} />
                      </div>
                      <div className="text-sm lg:text-lg">Sorting</div>{" "}
                    </div>
                  </div>
                  <div className="collapse-content"></div>
                </div>
                
                <div className="collapse collapse-plus join-item border border-base-300">
                  <input type="radio" name="my-accordion-4" />
                  <div className="collapse-title  ">
                    <div className="flex flex-row items-center">
                      <div className="pr-4 rotatex">
                        <ArrowCounterclockwise size={22} />
                      </div>
                      <div className="text-sm lg:text-lg">Flashcards</div>{" "}
                    </div>
                  </div>
                  <div className="collapse-content"></div>
                </div>
                 Indexes*/}
                <li className="gap-2 ">
                  <details close className="space-x-0">
                    <summary className=" flex w-full justify-between rounded-lg bg-slate-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                      {" "}
                      <UiRadiosGrid size={30} />
                      Multiple Choice
                    </summary>
                    <ul className="before:bg-transparent   border-2 border-purple-100 my-2  ">
                      <div className="overflow-x-auto  ">
                        <OneChoiceGenerator openModal={openModal} />
                      </div>
                    </ul>
                  </details>
                  <details close className="space-x-0">
                    <summary className=" flex w-full justify-between rounded-lg bg-slate-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                      {" "}
                      <ListUl size={30} />
                      Bullet List
                    </summary>
                    <ul className="before:bg-transparent   border-2 border-purple-100 my-2  ">
                      <div className="overflow-x-auto  ">
                        <BulletListGenerator openModal={openModal} />
                      </div>
                    </ul>
                  </details>
                  <details close className="space-x-0">
                    <summary className=" flex w-full justify-between rounded-lg bg-slate-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                      {" "}
                      <Image size={30} />
                      Image
                    </summary>
                    <ul className="before:bg-transparent   border-2 border-purple-100 my-2  ">
                      <div className="overflow-x-auto ">
                        <ImageGenerator
                          openModal={openModal}
                          session={session}
                        />
                      </div>
                    </ul>
                  </details>
                  <details close className="space-x-0">
                    <summary className=" flex w-full justify-between rounded-lg bg-slate-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                      {" "}
                      <Crosshair size={30} />
                      Labeled Image
                    </summary>
                    <ul className="before:bg-transparent   border-2 border-purple-100 my-2  ">
                      <div className="overflow-x-auto ">
                        <ImageMarkerGenerator
                          openModal={openModal}
                          session={session}
                        />
                      </div>
                    </ul>
                  </details>
                  <details close className="space-x-0">
                    <summary className=" flex w-full justify-between rounded-lg bg-slate-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                      {" "}
                      <Image size={30} />
                      Video
                    </summary>
                    <ul className="before:bg-transparent   border-2 border-purple-100 my-2  ">
                      <div className="overflow-x-auto ">
                        <VideoGenerator
                          openModal={openModal}
                          session={session}
                        />
                      </div>
                    </ul>
                  </details>
                  <details close className="space-x-0">
                    <summary className=" flex w-full justify-between rounded-lg bg-slate-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                      <Copy size={30} />
                      Sorting
                    </summary>
                    <ul className="before:bg-transparent   border-2 border-purple-100 my-2  ">
                      <div className="overflow-x-auto ">
                        <SortingGenerator openModal={openModal} />
                      </div>
                    </ul>
                  </details>
                  <details close className="space-x-0">
                    <summary className="flex w-full justify-between rounded-lg bg-slate-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                      {" "}
                      <ArrowCounterclockwise size={30} />
                      Flip Cards
                    </summary>
                    <ul className="before:bg-transparent  border-2 border-purple-100 my-2 ">
                      <div className="overflow-x-auto ">
                        <FlipCardGenerator openModal={openModal} />
                      </div>
                    </ul>
                  </details>
                  <details close className="space-x-0">
                    <summary className="flex w-full justify-between rounded-lg bg-slate-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                      {" "}
                      <Grid size={30} />
                      Flip Cards (Grid)
                    </summary>
                    <ul className="before:bg-transparent  border-2 border-purple-100 my-2 ">
                      <div className="overflow-x-auto ">
                        <FlipCardGridGenerator openModal={openModal} />
                      </div>
                    </ul>
                  </details>
                  <details close className="space-x-0">
                    <summary className="flex w-full justify-between rounded-lg bg-slate-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                      {" "}
                      <Fonts size={30} />
                      Text & HTML
                    </summary>
                    <ul className="before:bg-transparent  border-2 border-purple-100 my-2 ">
                      <div className="overflow-x-auto ">
                        {" "}
                        <TextGenerator openModal={openModal} />
                      </div>
                    </ul>
                  </details>
                  <details close className="space-x-0">
                    <summary className="flex w-full justify-between rounded-lg bg-slate-100 px-4 py-2 text-left text-sm font-medium text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500/75">
                      {" "}
                      <Code size={30} />
                      iframe Embedding
                    </summary>
                    <ul className="before:bg-transparent  border-2 border-purple-100 my-2 ">
                      <div className="overflow-x-auto ">
                        {" "}
                        <IframeGenerator openModal={openModal} />
                      </div>
                    </ul>
                  </details>
                </li>
              </div>
            ) : (
              <></>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}
